//@flow
import {
  SUBMIT_ANSWERS_REQUESTING,
  GET_CAMPAIGN_SURVEY_REQUESTING,
  GET_ACTIVE_SURVEY_REQUESTING,
  GET_SURVEY_REQUESTING,
  GET_ONBOARDING_SURVEY_REQUESTING,
} from "./constants";

// utilisé ?
export const getCampaignSurveyRequest = payload => {
  return {
    type: GET_CAMPAIGN_SURVEY_REQUESTING,
    payload,
  };
};

export const getSurveyRequest = payload => {
  return {
    type: GET_SURVEY_REQUESTING,
    payload,
  };
};

export const getActiveSurveyRequest = payload => {
  return {
    type: GET_ACTIVE_SURVEY_REQUESTING,
    payload,
  };
};

export const submitAnswersRequest = payload => {
  return {
    type: SUBMIT_ANSWERS_REQUESTING,
    payload,
  };
};

export const getOnboardingSurveyRequest = payload => {
  return {
    type: GET_ONBOARDING_SURVEY_REQUESTING,
    payload,
  };
};
